//消费打折
const PosList = () => import(/*webpackChunkName:'sale'*/"@/page/sale/discount/posList.vue")
const PAndEQrcode = () => import(/*webpackChunkName:'sale'*/"@/page/sale/discount/pAndEQrcode.vue")
const PrivilegesAndExemptions = () => import(/*webpackChunkName:'sale'*/"@/page/sale/discount/privilegesAndExemptions.vue")

const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')

export  const discount=
    {
        path: '/main/discount',
        name: '消费打折',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/discount/posList',
            name: '商户管理',
            meta: {
                requireAuth: true,
            },
            component: PosList
        },
        {
            path: '/main/discount/privilegesAndExemptions',
            name: '优免规则',
            meta: {
                requireAuth: true,
            },
            component: PrivilegesAndExemptions
        }, {
            path: '/main/discount/pAndEQrcode',
            name: '优免二维码',
            meta: {
                requireAuth: true,
            },
            component: PAndEQrcode
        }]
    }